module.exports = "<div class=\"rb-bid-menu\">\n  <rb-bid-manager-actions-list actions=\"actions\"></rb-bid-manager-actions-list>\n</div>\n";